/**
 * The currency of the country the viewer actually sits in — user.country, else
 * the tenant's country. Distinct from `useDefaultCurrency()`, which is the
 * currency they transact in: someone in Israel may run their books in EUR and
 * still want ILS within reach.
 */

import { useAuth } from '../auth';
import { useTenantLocaleSettings } from './useTenantSettings';
import countriesConfig from '../../shared-config/countries.config.json';

interface CountryConfigData {
  currency: string;
}

const countries = countriesConfig.countries as Record<string, CountryConfigData>;

/** ISO 4217 code for the viewer's country, or null when the country is unknown. */
export function useLocalCurrency(): string | null {
  const { user } = useAuth();
  const { data: tenantSettings } = useTenantLocaleSettings();

  const country = user?.country || tenantSettings?.country;
  if (!country) return null;

  return countries[country]?.currency ?? null;
}
